import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { default as MuiSwitch } from '@material-ui/core/Switch'
import type { SwitchProps as MuiSwitchProps } from '@material-ui/core/Switch'

const useStyles = makeStyles<Theme, SwitchProps>((theme) => ({
  root: {
    pointerEvents: ({ readOnly }: any) => (readOnly ? 'none' : 'auto'),
    position: 'relative',
    width: 42,
    height: 22,
    padding: 0,
    margin: theme.spacing(),
    '&::before': {
      content: (props) => (props.overlay ? `"${props.overlay}"` : ''),
      position: 'absolute',
      color: (props) => {
        if (props.disabled) {
          return theme.paintscout.palette.brand.Neutral.P70
        }

        return props.checked ? theme.palette.common.white : theme.paintscout.palette.brand.Neutral.P35
      },
      ...theme.typography.overline,
      top: '50%',
      left: (props) => (props.checked ? '0.6rem' : 'auto'),
      right: (props) => (props.checked ? 'auto' : '0.5rem'),
      transform: 'translateY(-50%)'
    }
  },
  sizeSmall: {
    '& $switchBase': {
      padding: 1
    },
    '&$root': {
      height: 18,
      width: 36
    },
    '&$root::before': {
      fontSize: '0.75em'
    }
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      '&:not($disabled)': {
        color: theme.palette.common.white
      },
      '&:not($disabled) + $track': {
        backgroundColor: theme.paintscout.palette.semantic.Success.S70,
        opacity: 1,
        border: 'none'
      }
    }
  },
  thumb: {
    width: 20,
    height: 20
  },
  track: {
    boxSizing: 'border-box',
    borderRadius: 13,
    border: `1px solid ${theme.paintscout.palette.brand.Neutral.P80}`,
    backgroundColor: theme.paintscout.palette.brand.Neutral.P85,
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border'])
  },
  checked: {},
  disabled: {}
}))

export interface SwitchProps extends Omit<MuiSwitchProps, 'inputProps'> {
  overlay?: string
  inputProps?: MuiSwitchProps & { 'data-testid'?: string }
}

const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(function Switch(props: SwitchProps, ref) {
  const classes = useStyles(props)
  return <MuiSwitch {...(props as any)} disableRipple classes={classes} ref={ref} />
})

export default Switch
